import useExportDataQuery from 'modules/maya/graphql/queries/exportData';

const useExport = () => (useExportDataQuery());

export default useExport;
